/** Typed wrapper over the Home overview aggregate. */
import type { HomeOverview } from '@portal/contracts'
import { apiFetch } from './portal-client'

/**
 * Everything the Home screen renders in one call. Sends the browser's
 * `Date.getTimezoneOffset()` so "this month" and the per-day histogram are
 * bucketed on the USER's calendar, not the server's.
 */
export function getHomeOverview(): Promise<HomeOverview> {
  return apiFetch<HomeOverview>(`/api/home?tzOffsetMinutes=${new Date().getTimezoneOffset()}`)
}
